<template>
  <!-- 法律法规-详情 -->
  <div class="eprights-contbox">
    <h3 class="artical-title">{{ doc_content.doc_title }}</h3>
    <div class="artical-info">
      <span>发布日期：{{ doc_content.compose_time?doc_content.compose_time.substring(0,10):''}}</span>
      <span class="line"></span>
      <span>浏览次数： {{ doc_content.hit_count }} </span>
      <span class="line"></span>
      <span
        >字体：[
        <span class="fonts" @click="sizeClick(3)" :class="{ cur: num === 3 }"
          >大</span
        >
        <span class="fonts" @click="sizeClick(2)" :class="{ cur: num === 2 }"
          >中</span
        >
        <span class="fonts" @click="sizeClick(1)" :class="{ cur: num === 1 }"
          >小</span
        >
        ]</span
      >
    </div>
    <div class="artical-detail">
      <!-- <h3 class="artical-title small">江苏省女职工劳动保护特别规定</h3> -->
      <div class="text-box" >
<!--        <p v-html="doc_content.content"></p>-->
        <div
          v-html="doc_content.content"
          class="data-details ql-editor"
          :style="{ fontSize: fontSize + 'px' }"
        ></div>
      </div>
    </div>
    <div class="btn-box">
      <a-button type="primary" @click="closeCase">关闭</a-button>
    </div>
  </div>
</template>
<script>
import { getOneDoc,hit } from '@/api/document';
export default {
  name: 'Regulations',
  data() {
    return {
      doc_content: {},
      fontSize: 14,
      num: 1,
    };
  },
  mounted() {
    this.getOneDoc();
  },
  methods: {
    getOneDoc() {
      let docid = this.$route.query.doc_id;
      getOneDoc(docid).then((res) => {
        this.doc_content = res;
      });
      hit({pkid:docid});
    },
    sizeClick(num) {
      if (num === 3) {
        this.fontSize = 18;
        this.num = 3;
      } else if (num === 2) {
        this.fontSize = 16;
        this.num = 2;
      } else {
        this.fontSize = 14;
        this.num = 1;
      }
    },
    closeCase() {
      window.close();
    },
  },
};
</script>
<style scoped>
.eprights-cont {
  display: inherit;
  padding: 0 10px;
}
.eprights-contbox{
  padding: 0 10px;
}
.left-tabs {
  width: 260px;
  text-align: center;
  padding-top: 20px;
}
.left-tabs a {
  display: inline-block;
  width: 220px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  font-size: 18px;
  color: #666;
  background: #fafbfc;
  border: 1px solid #d9dfe8;
  box-sizing: border-box;
}
.left-tabs a + a {
  margin-top: 10px;
}
.left-tabs a.active {
  color: #0079df;
  background: #f3f9ff;
  border: 1px solid #78c1ff;
}
.right-laws {
  flex: 1;
  padding-top: 10px;
  padding-right: 20px;
}
.fonts {
  margin: 0 5px;
  cursor: pointer;
}
.fonts.cur {
  font-weight: bold;
  color: #333;
}
.artical-title {
  font-weight: normal;
  color: #333;
  font-size: 24px;
  font-family: '微软雅黑';
  text-align: center;
  margin-bottom: 0;
  line-height: 1;
  padding: 15px 0 30px 0;
}
.artical-detail >>> ul{
  list-style: none;
}
.artical-title.small {
  font-size: 16px;
  padding: 25px 0 15px 0;
}
.artical-info {
  height: 28px;
  line-height: 28px;
  background: #f7f9fa;
  border: 1px solid #dbdee1;
  text-align: center;
  font-size: 14px;
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.artical-info span {
  display: inline-block;
}
.line {
  width: 2px;
  height: 15px;
  background: #c2c3c3;
  margin: 0 25px;
}
.text-box{min-height: 400px;}
.text-box p {
  margin-bottom: 0;
  line-height: 40px;
  text-indent: 28px;
  color: #555;

}
.btn-box {
  text-align: center;
  padding: 40px 0;
}
/deep/ .data-details img {
  width: 90%;
  margin: 0 auto;
  display: block;
}
</style>
